
<template>
  <div>
    <mdb-modal
      centered
      @close="$store.commit('clearCurrentModal')"
      elegant
      size="lg"
    >
      <mdb-modal-header>
        <mdb-modal-title class="isi-heading-blue">Test Types</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="d-flex flex-column pt-0">
        <h3 class="isi-sub-heading-gray mb-3">
          Sensory Lab Test
          <span
            >&minus; Quantitative project that must be carried out strictly in
            Sensory Labs.</span
          >
        </h3>
        <h3 class="isi-sub-heading-gray mb-3">
          Quantitative Studio Test
          <span
            >&minus; Quantitative project that does not necessarily has to be
            carried out in a Sensory Lab.</span
          >
        </h3>
        <mdb-btn
          class="btn btn-isi align-self-center"
          @click.native="$store.commit('clearCurrentModal')"
          >Ok</mdb-btn
        >
      </mdb-modal-body>
    </mdb-modal>
  </div>
</template>

<script>
export default {
  name: "InfoTestType",
};
</script>

<style scoped>
</style>